import { useEffect, useState } from "react";

export type CmtsNetworkStatus = "online" | "offline";

export function useCmtsNetworkStatus(): CmtsNetworkStatus {
  const [status, setStatus] = useState<CmtsNetworkStatus>(() => (typeof navigator !== "undefined" && navigator.onLine === false ? "offline" : "online"));
  useEffect(() => {
    const onOnline = () => setStatus("online");
    const onOffline = () => setStatus("offline");
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);
  return status;
}

export function CmtsNetworkStatusBanner() {
  const status = useCmtsNetworkStatus();
  if (status === "online") return null;
  return (
    <div className="cmts-pwa-banner" role="status" aria-live="polite">
      Offline mode is active. CMTS will keep the app shell available, but live complaint data, evidence, reports, audit logs and workflow actions require network access.
    </div>
  );
}
